export enum ConfirmRemoveHouseholdDialogModes {
  NotOriginallyCreated = 1,
  Permission,
  NotOriginallyCreatedAndPermission,
}
